import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a GA4 `page_view` event on every React Router navigation.
 * The initial page load is NOT tracked here (send_page_view: false in index.html)
 * because we handle it ourselves so SPA route changes are counted consistently.
 */
export default function useAnalytics() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: pathname + search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search]);
}
